import { fetchConfig } from "./FetchConfig";
import { getApi } from '../services/api/api'

export const fetchSensors = async (sensorData,baseurl,keystring) => {
    let sensorMatrix = [];
    for (let [key, value] of Object.entries(sensorData)) {
        let sensorName = value.pottieDescriptionShort.toLowerCase();
        let url = baseurl+'/api/states/sensor.'+sensorName+'_daten';
        let sensorResponse = await getApi(url,keystring);
        sensorMatrix.push(sensorResponse.data.attributes);
    }
    return sensorMatrix;
}